import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import { list, find, save, remove } from '../../services/inventoryLog'

function* fetchInventoryLogsRefresh() {
  const fe = JSON.parse(localStorage.getItem('fetchInventoryLogs'))
  if (fe == null) {
    fe.size = localStorage.getItem('pageSize') || 15
    fe.index = 0
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  }
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
  yield put({
    type: actions.LIST_INVENTORYLOG,
    result,
  })
}

function* fetchInventoryLogs({ size, index, searchTerm, orderBy }) {
  // Load last params froom last session.
  if (!size && !index && !searchTerm && !orderBy) {
    const fe = null
    if (fe != null) {
      size = fe.size || 15
      index = fe.index || 0
      searchTerm = fe.searchTerm || '%20'
      orderBy = fe.orderBy || '%20'
    } else {
      size = size || localStorage.getItem('pageSize') || 15
      index = 0
      searchTerm = '%20'
      orderBy = '%20'
    }
  }
  localStorage.setItem('fetchInventoryLogs', JSON.stringify({ size, index, searchTerm, orderBy }))
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, size, index, searchTerm, orderBy)
  yield put({
    type: actions.LIST_INVENTORYLOG,
    result,
  })
}

function* fetchInventoryLogEdit({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id)
  yield put({
    type: actions.EDIT_INVENTORYLOG,
    result,
  })
}

function* fetchInventoryLogSave(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(save, values)
  if (result !== null) {
    notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
  }
  yield put({
    type: actions.SAVE_INVENTORYLOG_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_INVENTORYLOGS,
  })
}

function* fetchInventoryLogDelete(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, values)
  if (result !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.DELETE_INVENTORYLOG_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_INVENTORYLOGS,
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_INVENTORYLOGS, fetchInventoryLogs),
    takeEvery(actions.FETCH_INVENTORYLOG, fetchInventoryLogEdit),
    takeEvery(actions.SAVE_INVENTORYLOG, fetchInventoryLogSave),
    takeEvery(actions.DELETE_INVENTORYLOG, fetchInventoryLogDelete),
    takeEvery(actions.RE_FETCH_INVENTORYLOGS, fetchInventoryLogsRefresh),
  ])
}
